import { useEffect, useState } from "react";
import { devDebug } from "../loggingHelpers";

export const usePlaywrightEnv = () => {
  const [env, setEnv] = useState<Record<string, unknown>>({});
  useEffect(() => {
    for (const prop in window) {
      if (
        prop === "playwright" &&
        typeof window.playwright === "object" &&
        null !== window.playwright
      ) {
        devDebug(`window.playwright: ${JSON.stringify(window.playwright)}`);
        setEnv(window.playwright);
      }
    }
  }, []);
  return env;
};
